<script>

export default {
  name: 'payment-method',
  props: {
    paymentMethod: {
      type: String,
      required: true,
    },
  },
  methods: {
    setPaymentMethod(paymentMethod) {
      this.$emit('change-payment-method', paymentMethod);
    },
  },
};
</script>

<template>
  <div>
    <div class="row col-md-12" style="margin-bottom: 25px;">
      <h3 slot="header" class="title">
        Forma de pagamento
      </h3>
    </div>

    <div class="form-row">
      <div class="form-group col-md-12">
        <div
          id="formFormaPagamento"
          class="btn-group col-md-12"
          role="group"
          aria-label="Forma de pagamento"
        >
          <button
            type="button"
            :class="
              paymentMethod === 'pix'
                ? 'btn btn-outline-dark active'
                : 'btn btn-outline-dark'
            "
            @click="setPaymentMethod('pix')"
          >
            Pix
          </button>
          <button
            type="button"
            :class="
              paymentMethod === 'bankslip'
                ? 'btn btn-outline-dark active'
                : 'btn btn-outline-dark'
            "
            @click="setPaymentMethod('bankslip')"
          >
            Boleto
          </button>
          <button
            type="button"
            :class="
              paymentMethod === 'creditcard'
                ? 'btn btn-outline-dark active'
                : 'btn btn-outline-dark'
            "
            @click="setPaymentMethod('creditcard')"
          >
            Cartão de Crédito
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
